import { gsap, Power3 } from "gsap";

export default class MobileNav {
    constructor() {

      this.toggle = document.querySelectorAll(".js-nav-toggle");
      this.subNavs = document.querySelectorAll(".js-sub-nav");
      this.closeSubNavTrigger = document.querySelectorAll(".js-sub-nav-close");
      this.nav = document.querySelector(".mobile-nav");

      this.init();
    }

    init() {

      this.toggle.forEach(element => {
        element.addEventListener("click", (e) => {
          this.toggleNav();
        });
        element.addEventListener("keydown", (e) => {
          if (e.code === "Enter") {
            this.toggleNav();
          }
        });
      });

      this.subNavs.forEach(element => {
        element.addEventListener("click", (e) => {
          e.preventDefault();
          this.openSubNav(element);
        });
        element.addEventListener("keydown", (e) => {
          e.preventDefault();
          if (e.code === "Enter") {
            this.openSubNav(element);
          }
        });
      });

      this.closeSubNavTrigger.forEach(element => {
        element.addEventListener("click", (e) => {
          this.closeSubNav(element);
        });
        element.addEventListener("keydown", (e) => {
          if (e.code === "Enter") {
            this.closeSubNav(element);
          }
        });
      });

      window.addEventListener('resize', () => {
        document.querySelector('.mobile-nav').style.height = window.innerHeight -  document.querySelector('main').getBoundingClientRect().top + 'px';
        document.querySelectorAll('.mobile-nav__sub').forEach(element => {
          element.style.height = window.innerHeight - document.querySelector('header').getBoundingClientRect().top + 'px';
          element.style.top = window.pageYOffset + document.querySelector('header').getBoundingClientRect().top + 'px';
        });
      });

    }

    toggleNav() {

      if(!this.nav.classList.contains('mobile-nav--active')){
        window.scrollTo(0,0);
        document.body.classList.add('no-scroll');
        this.nav.classList.add('mobile-nav--active');
        document.querySelector('.mobile-nav__toggle').classList.add('mobile-nav__toggle--active');
        gsap.to(this.nav, {
            duration: .3,
            delay: .25,
            top: window.pageYOffset + document.querySelector('main').getBoundingClientRect().top,
            height: window.innerHeight - document.querySelector('main').getBoundingClientRect().top,
            display: 'block',
            ease: Power3.in
        });
      } else {
        document.body.classList.remove('no-scroll');
        this.nav.classList.remove('mobile-nav--active');
        document.querySelector('.mobile-nav__toggle').classList.remove('mobile-nav__toggle--active');
        gsap.to(this.nav, {
            duration: .3,
            delay: .25,
            top: '100%',
            display: 'none',
            ease: Power3.in
        });
      }

    }
    openSubNav(trigger) {
      gsap.to(trigger.nextElementSibling, {
          duration: .3,
          delay: .25,
          height: window.innerHeight - document.querySelector('header').getBoundingClientRect().top,
          left: 0,
          display: 'block',
          ease: Power3.in,
          onStart: () => {
            trigger.nextElementSibling.style.top = window.pageYOffset + document.querySelector('header').getBoundingClientRect().top + 'px';
          }
      });
    }
    closeSubNav(trigger) {
      gsap.to(trigger.closest('.mobile-nav__sub'), {
          duration: .3,
          delay: .25,
          left: '-100%',
          display: 'none',
          ease: Power3.in
      });
    }
}
